<template>
  <div class="d-book-exit-modal">
    <DExitModal
      id="exit-modal"
      data-modal-name="Book exit modal"
      :data-modal-test="test"
    >
      <template #modal-image>
        <img
          class="book-cover"
          :src="images.img"
        >

        <div class="book-background">
          <div
            class="background-blur"
            :style="{ 'background-image': 'url(' + images.background + ')' }"
          />
        </div>
      </template>

      <template #modal-body>
        <slot name="modal-body" />
      </template>
    </DExitModal>
  </div>
</template>

<script>
import DExitModal from '@d-shared/components/exit-modals/d-exit-modal/d-exit-modal.vue';

export default {
  components: {
    DExitModal,
  },
  props: {
    isDiscoveryBook: {
      type: Boolean,
      required: true,
    },
    images: {
      type: Object,
      required: true,
    },
    test: {
      type: String,
      required: true,
    },
  },
};
</script>
